import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';

import Dialog from '../../components/Dialog/Dialog';
import { ButtonDefault, ButtonPrimary } from '../../components/Button/Button';
import SelectOption from '../../components/Inputs/Select/Select';
import Text from '../../components/Inputs/Text/Text';
import Toast from '../../components/Toast/Toast';

import CandidatoService from '../../services/Candidato';
import { errors } from '../../services/API';

import DocumentoViewer from '../../forms/Documento/DocumentoViewer';

import { isBlank, isBlankHelperText } from '../../helper/ValidationHelper';
import { isInscricoesAbertas } from '../../helper/ContextHelper';
import { getFilenameResponse, base64ToFile } from '../../helper/FileHelper';

import LinkTargetBlank from '../../components/Link/Link';
import { patternNome } from '../Candidato/Candidato';

export class DialogTratamentoDocumento extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            open: false,
            loading: false,
            documento: null,
            file: null,
            status: '',
            justificativa: '',
            escolaInvalida: false,
            escolaEmAnalise: false,
            errors: {
                status: false,
                justificativa: false,
            },
            helpers: {
                status: null,
                justificativa: null,
            },
        }
    }

    setToast = t => this.Toast = t;

    toBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);

            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
        });
    };

    openModal = (documento) => {
        CandidatoService.downloadDocumento(documento.candidato.id, documento.id)
            .then(res => {

                const fileName = getFilenameResponse(res);

                this.toBase64(res.data).then(base64 => {

                    const file = base64ToFile(base64, fileName);

                    this.setState({
                        open: true,
                        loading: false,
                        documento: documento,
                        file: file,
                        status: documento.validacao.status ?? '',
                        justificativa: documento.validacao.justificativa ?? '',
                        escolaInvalida: documento?.candidato?.escola?.invalida,
                        escolaEmAnalise: documento?.candidato?.escola?.status === 'EM_ANALISE',
                        errors: {
                            status: false,
                            justificativa: false,
                        },
                        helpers: {
                            status: null,
                            justificativa: null,
                        },
                    });

                });
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: 'Erro ao buscar documento',
                        type: e.type,
                        open: true
                    }
                });
            });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: null },
        });
    }

    isValid = () => {
        const { status, justificativa } = this.state;

        const statusInvalido = isBlank(status);
        const justificativaInvalida = status === 'INVALIDO' && isBlank(justificativa);

        if (statusInvalido || justificativaInvalida) {
            this.setState({
                errors: {
                    status: statusInvalido,
                    justificativa: justificativaInvalida,
                },
                helpers: {
                    status: statusInvalido ? isBlankHelperText() : null,
                    justificativa: justificativaInvalida ? isBlankHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    handleConfirm = () => {
        this.setState({ loading: true });

        if (!this.isValid()) {
            this.setState({ loading: false });
            return;
        }

        const tratamento = {
            status: this.state.status,
            justificativa: this.state.justificativa,
        }

        CandidatoService.tratarDocumento(this.state.documento.candidato.id, this.state.documento.id, tratamento)
            .then(() => {
                this.Toast.setState({
                    message: {
                        message: "Tratamento de documento realizado com sucesso",
                        type: 'success',
                        open: true
                    }
                });
                this.handleClose();
                this.props.handleConfirm();
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    componentDidMount() {
        this.props.loadPeriodos();
    }

    render() {
        const isPodeSerValidado = isInscricoesAbertas(this.props.contexts) && this.state.documento && this.state.documento.candidato.dataFinalizacaoInscricao == null && (!this.state.escolaInvalida && !this.state.escolaEmAnalise);

        return (
            <>
                <Toast parentRef={this.setToast} />
                <Dialog
                    openDialog={this.state.open}
                    title={"Tratamento de Comprovante de Vínculo de Candidato"}
                    closeDialog={this.handleClose}
                    actions={
                        <>
                            <ButtonPrimary
                                onClick={this.handleConfirm}
                                startIcon={<CheckOutlinedIcon />}
                                style={{ margin: 4 }}
                                name="Salvar"
                                loading={this.state.loading}
                                disabled={!isPodeSerValidado}
                            />
                            <ButtonDefault
                                onClick={this.handleClose}
                                startIcon={<ClearOutlinedIcon />}
                                style={{ margin: 4 }}
                                name="Fechar"
                            />
                        </>
                    }
                    fullWidth={true}
                    maxWidth={"lg"}
                >
                    <div style={{ height: '70vh', display: 'flex', flexDirection: 'column' }}>
                        {this.state.escolaInvalida ? (
                            <Grid item style={{ marginBottom: 16 }}>
                                <Alert severity="error">
                                    <b>ATENÇÃO:</b> A escola <b>{this.state.documento?.candidato?.escola?.inep} - {this.state.documento?.candidato?.escola?.nome} - {this.state.documento?.candidato?.escola?.dependenciaAdministrativa}</b> selecionada pelo candidato foi <b>Reprovada</b> pela equipe da OBMEP.
                                    <br />
                                    Não é Possível Tratar o Documento de uma Escola que não é Válida.
                                    <br />
                                    <LinkTargetBlank link={`${process.env.REACT_APP_PUBLIC_MIRIM_URL}/admin/escola/${this.state.documento?.candidato?.escola?.inep}/editar#ocorrencias`}>CLIQUE AQUI</LinkTargetBlank> para visualizar o tratamento desta escola.
                                </Alert>
                            </Grid>
                        ) : this.state.escolaEmAnalise ? (
                            <Grid item style={{ marginBottom: 16 }}>
                                <Alert severity="warning">
                                    <b>ATENÇÃO:</b> A escola <b>{this.state.documento?.candidato?.escola?.inep} - {this.state.documento?.candidato?.escola?.nome} - {this.state.documento?.candidato?.escola?.dependenciaAdministrativa}</b> selecionada pelo candidato está sendo analisada pela equipe da OBMEP.
                                    <br />
                                    Não é Possível Tratar o Documento de uma Escola que não é Válida.
                                    <br />
                                    <LinkTargetBlank link={`${process.env.REACT_APP_PUBLIC_MIRIM_URL}/admin/escola/${this.state.documento?.candidato?.escola?.inep}/editar#ocorrencias`}>CLIQUE AQUI</LinkTargetBlank> para realizar o tratamento desta escola.

                                </Alert>
                            </Grid>
                        ) : (
                            <Grid item style={{ marginBottom: 16 }}>
                                <Alert severity="info">
                                    A escola <b>{this.state.documento?.candidato?.escola?.inep} - {this.state.documento?.candidato?.escola?.nome} - {this.state.documento?.candidato?.escola?.dependenciaAdministrativa}</b> foi selecionada pelo candidato.
                                </Alert>
                            </Grid>
                        )}

                        <Grid container spacing={3} style={{ flex: 1, minHeight: 0 }}>
                            <Grid item xs={12} md={8} xl={8}>
                                <DocumentoViewer file={this.state.file} withRotate={true} />
                            </Grid>

                            <Grid item xs={12} md={4} xl={4} style={{ display: 'flex', minHeight: 0 }}>
                                <Grid
                                    container
                                    direction="column"
                                    style={{
                                        height: '100%',
                                    }}
                                >
                                    <Grid item>
                                        <Typography variant="subtitle2" color="textSecondary">
                                            Candidato
                                        </Typography>
                                        <Typography variant="body1" style={{ marginBottom: 10 }}>
                                            {patternNome(this.state.documento?.candidato?.nomeExibicao, this.state.documento?.candidato?.nomeSocial, this.state.documento?.candidato?.nome)}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Text
                                            required
                                            fullWidth
                                            multiline
                                            label="Tipo de Documento"
                                            name="tipoDocumento"
                                            value={this.state.documento ? this.state.documento.tipo.nome : ''}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <SelectOption
                                            required
                                            label="Status de Validação"
                                            name="status"
                                            value={this.state.status}
                                            error={this.state.errors.status}
                                            onChange={this.handleChange}
                                            helperText={this.state.helpers.status}
                                            options={this.props.optionsStatusValidacao}
                                            hiddenblank={true}
                                        />
                                    </Grid>
                                    {(this.state.status === 'INVALIDO' || this.state.status === 'EM_TRATAMENTO') && (
                                        <Grid item>
                                            <Text
                                                required={this.state.status === 'INVALIDO'}
                                                label="Justificativa"
                                                name="justificativa"
                                                value={this.state.justificativa}
                                                error={this.state.errors.justificativa}
                                                onChange={this.handleChange}
                                                helperText={this.state.helpers.justificativa}
                                                multiline
                                                rows={4}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>


                    </div>
                </Dialog >
            </>
        )
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(DialogTratamentoDocumento);
